// extracted by mini-css-extract-plugin
export default {"simple-list":"SimpleList_simple-list__Yf-RA","drop-marker":"SimpleList_drop-marker__vKqrn","drop-spacing":"SimpleList_drop-spacing__FlAqz"};